import * as React from 'react';

function NavClient(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 128 128"
            {...props}
        >
            <path
                d="M118,98.37a4.9,4.9,0,0,1-4.91,4.9H54.18a4.9,4.9,0,0,1-4.91-4.9h0A29.46,29.46,0,0,1,78.73,68.91h9.82A29.46,29.46,0,0,1,118,98.37ZM83.63,24.73a19.63,19.63,0,1,0,19.64,19.63h0A19.63,19.63,0,0,0,83.63,24.73Zm-44.18,0A19.63,19.63,0,1,0,59.09,44.37,19.63,19.63,0,0,0,39.45,24.73h0Zm0,73.63A39,39,0,0,1,51,70.63a26.31,26.31,0,0,0-9.37-1.72H37.3A27.35,27.35,0,0,0,10,96.21v2.16a4.9,4.9,0,0,0,4.91,4.9H40.34a14.89,14.89,0,0,1-.89-4.9Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default NavClient;
